import { environment } from "../../environments/environment"
import { CamposDinamicos } from "./campos-dinamicos";
import { DestinoDomicilioCasa } from "./destinoDomicilioCasa";
import { PrametroEmpresa } from "./parametroEmpresa";

export class Usuario {
  public ServicioRetorno: boolean;
  public Abono: string
  public Activo: boolean
  public Adicional: string
  public Birthday: Date
  public BirthdayInt: number
  public Campos: string
  public CargoLaboral: string
  public Celular: string
  public CentroCosto_Codigo: string
  public Clave: string
  public ClienteObs: string
  public CodigoActivacion: string
  public CodigoTrabajador: string
  public Creacion_Fecha: any
  public Creacion_Usuario: String
  public DNI: string
  public Dias: string
  public Direccion: string
  public DireccionNumero: string
  public Distrito: string
  public DocumentoIdentidad: string
  public EditCC: number
  public Email: string
  public Area: string
  public EstadoPresupuesto: boolean
  public Exigente: string
  public FlagPresupuesto: string
  public Fonema: string
  public listaClienteEncargo: string[];
  public HoraFinServicio: string
  public HoraInicioServicio: string
  public HoraFinEspecialServicio: string
  public HoraInicioEspecialServicio: string
  public HoraExtendidoFinServicio: string
  public HoraExtendidoInicioServicio: string

  public idAprobador: number
  public IMEI: string
  public IdCentroCosto: number
  public IdCliente: number // id Cliente = null
  public IdEmpresa: number
  public IdEmpresaPrev: number
  public IdSupervisor: number
  public Latitud: number
  LimiteServicios: number
  public Longitud: number
  public latitudEmpresa: number
  public longitudEmpresa: number
  public LstTarjetas: any[];
  public Materno: string
  public Modifico_Fecha: any
  public Modifico_Usuario: String
  public NombreCompleto: string
  public Nombres: string
  public OrdenInterno: string
  public Paterno: string
  public pedirTercero: boolean
  public pedirVisita: boolean
  public pedirPersonal: boolean
  public PrepagoDisponible: number
  public PrepagoRecibido: number
  public PrepagoUsado: number
  public Presupuesto: number
  public RUC: string
  public RazonSocial: string
  public Referencia: string
  public ReferenciaEmpresa: string
  public Rol: number
  public Suscripcion: string
  public Vip: string
  public Zona: string
  public consumo: number
  public nombreEmpresa: string
  public saldo: number
  public userTokenId: string
  public isoCountryCode: string
  public prefijo: String
  public isAdmin: boolean
  public isExtUser: boolean
  public FlagRecargo: boolean;
  public listaCentroCosto: any[];
  public listaEmpresa: any[];
  public listaPerfil: any[];
  public lstGeocerca: any[];
  public camposDinamicos: CamposDinamicos[];
  urlFoto: string = environment.URL_BASE + 'cliente/getpicture?id='
  idCodigoPromocional: number;
  public verEmpresaAprobacion: boolean
  public modoServicio: any;
  public cambioPresupuesto: boolean;
  public pinEditable: boolean;
  public lstCentroCosto: number[];
  public menu: any[];
  public idArea: number;
  public cReutilizable: string;
  //public pedirTercero: boolean;
  public LstSupervisores: any[];
  public recargoTarifa: number;
  public ComboAeropuerto: string;
  //Extension de presupuesto por mes
  public extensionPresupuesto: number;
  public extensionPresupuestoFecha: any;
  public busquedaNoEditable: boolean;
  public busquedaNoEditableEmpresa: boolean;
  public direccionEmpresa: string;
  public idzonaEmpresa: number;
  public EmailCliente:string;
  public lstCalificacion: any[];

  public  marker: google.maps.Marker;
  public lstMarkerDestino: DestinoDomicilioCasa[];
  public PedirPesonalEmpresaVisita :boolean
  public FlagMultipleAprobador:boolean
  public FlagEditarDestino:boolean
  public FlagSelectAprobador:boolean
  /**Agregado nuevo caso interbank   inicio */
  public cReutilizable2 : string;  /* Vice Presidencia */
  public cReutilizable3 : string;  /* Gerencia Central */
  public cReutilizable4 : string;  /* División */
  public cReutilizable5 : string;  /* Departamento*/
  public cReutilizable6 : string;  /* Sección */
  public cReutilizable7 : string;  /* Unidad */
  public ConfigEmpresa :PrametroEmpresa
  /** Fin */

  constructor() {
    this.lstMarkerDestino = [new DestinoDomicilioCasa(), new DestinoDomicilioCasa()];
    this.Celular = ""
    this.idCodigoPromocional = 0
    this.Abono = ""
    this.Activo = true
    this.Adicional = ""
    this.Birthday = new Date
    this.BirthdayInt = 0
    this.Campos = null
  
    this.CentroCosto_Codigo = "0"
    this.ClienteObs = "0"
    this.CodigoActivacion = ""
    this.CodigoTrabajador = ""
    this.Creacion_Fecha = ""
    this.Creacion_Usuario = ""
    this.DNI = ""
    this.Dias = ""
    this.Direccion = ""
    this.DireccionNumero = ""
    this.Distrito = ""
    this.DocumentoIdentidad = ""
    this.EditCC = 0
    this.EstadoPresupuesto = true
    this.Exigente = "0"
    this.FlagPresupuesto = "0"
    this.Fonema = "0"

    this.HoraInicioServicio = "00:00:00"
    this.HoraFinServicio = "23:59:59"
    this.HoraInicioEspecialServicio = "00:00:00"
    this.HoraFinEspecialServicio = "23:59:59"
    this.HoraExtendidoInicioServicio = "00:00:00"
    this.HoraExtendidoFinServicio = "23:59:59"

    this.idAprobador = 0
    this.IMEI = "0"
    this.IdCentroCosto = 0
    this.IdCliente = null// id Cliente = null
    this.IdEmpresaPrev = 0
    this.IdSupervisor = 0
    this.Latitud = 0
    this.LimiteServicios = 0
    this.Longitud = 0
    this.latitudEmpresa = 0
    this.longitudEmpresa = 0
    this.Materno = ""
    this.Modifico_Fecha = ""
    this.Modifico_Usuario = ""
    this.NombreCompleto = ""
   
    this.pedirTercero = false
    this.PrepagoDisponible = 0
    this.PrepagoRecibido = 0
    this.PrepagoUsado = 0
    this.Presupuesto = 0
    this.RUC = "0"
    this.RazonSocial = "0"
    this.Referencia = ""
    this.ReferenciaEmpresa= ""
    this.Rol = 0
    this.Suscripcion = "0"
    this.Vip = "0"
    this.Zona = "0"
    this.consumo = 0
    this.nombreEmpresa = "0"
    this.saldo = 0
    this.userTokenId = "0"
    this.isoCountryCode = "0"
    this.urlFoto = environment.URL_BASE + 'cliente/getpicture?id='
    this.prefijo = "+51"
    this.isAdmin = true
    this.isExtUser = false
    this.verEmpresaAprobacion = false;
    this.pedirTercero = false;
    this.pedirPersonal = false;
    this.cambioPresupuesto = false;
    this.pinEditable = false;
    this.lstCentroCosto = []
    this.idArea = -1
    this.Dias = '1111111';
    this.cReutilizable = "";
    this.extensionPresupuesto = 0;
    this.extensionPresupuestoFecha = "";
   this.busquedaNoEditable = false;
   this.EmailCliente="";

   
   this.cReutilizable2 = "";
   this.cReutilizable3 = "";
   this.cReutilizable4 = "";
   this.cReutilizable5 = "";
   this.cReutilizable6 = "";
   this.PedirPesonalEmpresaVisita = false
  }
}


export interface Usuario {
  Abono: string
  Activo: boolean
  Adicional: string
  Birthday: Date
  BirthdayInt: number
  Campos: string
  CargoLaboral: string
  Celular: string
  CentroCosto_Codigo: string
  Clave: string
  ClienteObs: string
  CodigoActivacion: string
  CodigoTrabajador: string
  Creacion_Fecha: any
  Creacion_Usuario: String
  DNI: string
  Dias: string
  Direccion: string
  DireccionNumero: string
  Distrito: string
  DocumentoIdentidad: string
  EditCC: number
  Email: string
  Area: string
  EstadoPresupuesto: boolean
  Exigente: string
  FlagPresupuesto: string
  Fonema: string

  HoraFinServicio: string
  HoraInicioServicio: string
  HoraFinEspecialServicio: string
  HoraInicioEspecialServicio: string
  HoraExtendidoFinServicio: string
  HoraExtendidoInicioServicio: string

  idAprobador: number
  IMEI: string
  IdCentroCosto: number
  IdCliente: number // id Cliente = null
  IdEmpresa: number
  IdEmpresaPrev: number
  IdSupervisor: number
  Latitud: number
  LimiteServicios: number
  Longitud: number
  latitudEmpresa: number
  longitudEmpresa: number
  LstTarjetas: any[];
  Materno: string
  Modifico_Fecha: any
  Modifico_Usuario: String
  NombreCompleto: string
  Nombres: string
  OrdenInterno: string
  Paterno: string
  pedirTercero: boolean
  pedirVisita: boolean
  pedirPersonal: boolean
  PrepagoDisponible: number
  PrepagoRecibido: number
  PrepagoUsado: number
  Presupuesto: number
  RUC: string
  RazonSocial: string
  Referencia: string
  ReferenciaEmpresa: string
  Rol: number
  Suscripcion: string
  Vip: string
  Zona: string
  consumo: number
  nombreEmpresa: string
  saldo: number
  userTokenId: string
  isoCountryCode: string
  prefijo: String
  isAdmin: boolean
  isExtUser: boolean

  listaCentroCosto: any[];
  listaEmpresa: any[];
  listaPerfil: any[];
  lstGeocerca: any[];
  camposDinamicos: CamposDinamicos[];
  urlFoto: string; //= environment.URL_BASE + 'cliente/getpicture?id='
  idCodigoPromocional: number;
  verEmpresaAprobacion: boolean
  modoServicio: any;
  cambioPresupuesto: boolean;
  pinEditable: boolean;
  lstCentroCosto: number[];
  menu: any[];
  idArea: number;

  extensionPresupuesto: number;
  extensionPresupuestoFecha: any;
  busquedaNoEditable : boolean;
  lstMarkerDestino : DestinoDomicilioCasa[]
  FlagMultipleAprobador:boolean
  lstAprobadores:number[]
  DobleAprobador:boolean
}